import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import './ConfirmDialog.scss';

const ConfirmationDialog = (props) => {
  const {
    title,
    message,
    buttons = [
      { title: 'Cancel', value: false },
      { title: 'Ok', value: true },
    ],
    onClose,
    ...other
  } = props;
  const handlers = buttons.map(button => () => onClose(button.value));
  const makeKey = (btn, i) => (btn.id || i);

  return (
    <Dialog
      disableBackdropClick
      maxWidth={props.maxWidth || 'xs'}
      aria-labelledby="confirmation-dialog-title"
      {...other}
      className="grb-confirm-dialog"
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        {message && message.split
          ? message.split('\n').map((m, i) => <Typography key={makeKey(m, i)}>{m}</Typography>)
          : <Typography>{message}</Typography>}
      </DialogContent>
      <DialogActions>
        {buttons.map((button, i) => (
          <Button onClick={handlers[i]} key={makeKey(button, i)} color="primary" id={button.id || undefined}>
            {button.title}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  maxWidth: PropTypes.string,
};

ConfirmationDialog.defaultProps = {
  buttons: undefined,
  maxWidth: undefined,
};

export default ConfirmationDialog;
